import moment from 'moment';

import { SshKeyListV4200RowsItem } from '@newfold/huapi-js/src/index.schemas';

import { SSHKey } from '~/components/SSHKeysTable';
import { PUB_EXTENSION_REGEX } from '~/utils/regex/constants';

import { DEFAULT_KEY_NAME, SSH_PUBLIC_KEY_REGEX } from './constant';

export const removePublicKeyExtension = (data: string): string => {
  return data.replace(PUB_EXTENSION_REGEX, '');
};

export const formatCreatedAt = (createdAt: string | undefined): string => {
  if (!createdAt) {
    return '';
  }
  return moment.utc(createdAt).local().format('MMM D, YYYY');
};

export const isValidSSHPublicKey = (value: string): boolean =>
  SSH_PUBLIC_KEY_REGEX.test(value.trim());

export const getDefaultKeyName = (
  sshKeyList: SshKeyListV4200RowsItem[] = [],
): string => {
  const names = sshKeyList.map(({ name }) => name);

  const isAvailable = (name: string) =>
    !names.includes(name) && !names.includes(`${name}.pub`);

  if (isAvailable(DEFAULT_KEY_NAME)) {
    return DEFAULT_KEY_NAME;
  }

  for (let index = 1; ; index += 1) {
    const keyName = `${DEFAULT_KEY_NAME}${index}`;

    if (isAvailable(keyName)) {
      return keyName;
    }
  }
};

export const getNormalizeSSHKeys = (
  sshKeys: SshKeyListV4200RowsItem[] = [],
): SSHKey[] =>
  sshKeys.map((key, index) => {
    const { id, name, type, created_at, pubkey } = key;

    return {
      id: id ?? index,
      name: name || '-',
      alg_type: type?.toUpperCase() || '-',
      addedAt: formatCreatedAt(created_at),
      createdAt: created_at,
      keyValue: pubkey || '',
      status: 'active',
    };
  });

export const getKeyType = (keyValue: string | undefined): string | undefined =>
  keyValue?.split(/\s+/)[0]?.replace('ssh-', '').toUpperCase();
